import { equals2 } from "fxjs/es";
export const hideEl = (self, el) => {
  self._checkNoProcessingTask();
  const selection = self._getSelectionThrowable();
  if (equals2("none")(el.getAttributeNS(null, "display"))) {
    return;
  }
  if (selection.getSelectedEls().has(el)) {
    selection.unselectEl(el);
  }
  el.setAttributeNS(null, "display", "none");
  el.dispatchEvent(
    new CustomEvent("@mp/sticker-editor/hide", {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        el,
      },
    })
  );
};
